import type { CreateTypes } from 'canvas-confetti'
import type React from 'react'
import { useCallback, useEffect, useRef } from 'react'
import ReactCanvasConfetti from 'react-canvas-confetti'

export const Confetti: React.FC = () => {
  const refAnimationInstance = useRef<CreateTypes | null>(null)

  const getInstance = useCallback((instance: CreateTypes | null) => {
    refAnimationInstance.current = instance
  }, [])

  // @ts-expect-error
  const makeShot = useCallback((particleRatio, opts) => {
    refAnimationInstance.current &&
      refAnimationInstance.current({
        ...opts,
        origin: { y: 0.48 },
        particleCount: Math.floor(500 * particleRatio),
      })
  }, [])

  useEffect(() => {
    makeShot(0.25, {
      spread: 26,
      startVelocity: 55,
      ticks: 400,
    })

    makeShot(0.2, {
      spread: 60,
      ticks: 400,
    })

    makeShot(0.35, {
      spread: 100,
      decay: 0.91,
      scalar: 0.8,
      ticks: 400,
    })

    makeShot(0.1, {
      spread: 120,
      startVelocity: 25,
      decay: 0.92,
      scalar: 1.2,
      ticks: 300,
    })

    makeShot(0.1, {
      spread: 120,
      startVelocity: 45,
      ticks: 300,
    })
  }, [makeShot])

  return (
    <ReactCanvasConfetti
      refConfetti={getInstance}
      style={{
        position: 'fixed',
        pointerEvents: 'none',
        width: '100%',
        height: '100%',
        top: 0,
        left: 0,
      }}
    />
  )
}
